<template>
  <div class="wrap">
    <div style="height: auto; width: 100%; position: relative">
      <span class="fl-l"
        >课程评分：<el-rate v-model="rate" show-score text-color="#ff9900" score-template="{value}">
          :colors="colors" style="margin: 5px;">
        </el-rate></span
      >
      <el-input
        type="textarea"
        @focus="focus"
        @blur="blur"
        :rows="4"
        placeholder="请输入评价"
        v-model="input"
      >
      </el-input>
      <div class="btnWrap">
        <!-- <v-btn small elevation="2" border="none" outlined color="teal" class="fl-l btnClass" @click="toggle">表情包</v-btn>  -->
        <span
          class="fl-l btnClass btn1"
          @click="toggle"
          style="
            padding: 5px 20px;
            border: 1px solid gray;
            border: 1px solid #e2e2e2;
            cursor: pointer;
            border-radius: 5px;
            margin-top: -1px;
            background-color: #fff;
          "
          >表情包</span
        >
        <span
          class="fl-r btnClass btn2"
          @click="submitMessage"
          style="
            padding: 5px 20px;
            border: 1px solid gray;
            border: 1px solid #e2e2e2 !important;
            cursor: pointer;
            border-radius: 5px;
            margin-top: 0px;
          "
          >发送</span
        >
        <!-- <v-btn small elevation="2" outlined color="green" class=" fl-r btnClass send">发送</v-btn>  -->
        <!-- <v-btn small elevation="2" outlined color="green" class="fl-r btnClass cancel">取消</v-btn>  -->
      </div>

      <div class="emoWrap" v-if="toggleVisib">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
          <el-tab-pane v-for="item in emoArr" :label="item.name" :name="item.name" :key="item.name">
            <div class="emoItemWrap">
              <span
                v-for="items in item.arr"
                :key="items.name"
                class="emoItem"
                @click="insertItem(items)"
                >{{ items.emo.trim() }}</span
              >
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
            <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
            <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
  </div>
</template>
    <script>
import moment from 'moment';
import { getdetailList, queryCourseThree, addMessage } from '@/api/simulation';
import emo from './emotion/emojis';
export default {
  // 话题讨论
  components: {},
  props: {
    routeData: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      toggleVisib: false,
      input: '',
      activeName: 'Frequen',
      textarea: '',
      avatar: require('./../../../assets/img/courseMessage.png'),
      value2: null,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      commentList: [],
      emoArr: [],
      rate: null,
    };
  },
  watch: {
    routeData: {
      handler(news) {
        //  console.log(news,'3333333333')
      },
      deep: true,
    },
  },
  methods: {
    submitMessage() {
      // console.log(this.routeData._id,this.routeData.courseId)

      let params = {
        courseId: this.routeData._id || '',
        simclassId: this.routeData._id || '',
        message: this.input,
        logImg: this.getUserLog().userLog || '',
        nickName: this.getUserLog().nickName || '',
        rate: this.rate,
      };
      addMessage(params).then(res => {
        if (res.code == '200') {
          this.$notify({
            timeout: 1500,
            message: '评论成功！',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.input = '';
          this.toggleVisib = false;
          this.$emit('quertTotal')
        }
      });
    },
    getUserLog() {
      if (window.localStorage.getItem('USER_INFO')) {
        let userData = JSON.parse(window.localStorage.getItem('USER_INFO'));
        if (userData && userData.user) {
          // return userData.user.avatar||'',
          return {
            userLog: userData.user.avatar || '',
            nickName: userData.user.nickName || '',
          };
        }
      }
    },
    insertItem(items) {
      console.log(items);
      this.input += items.emo;
    },
    toggle() {
      this.toggleVisib = !this.toggleVisib;
    },
    handleClick() {},
    filterEmo(data) {
      this.emoArr = [];
      for (var key in data) {
        let obj = {
          name: key,
          arr: [],
        };
        for (var keys in data[key]) {
          let emos = data[key][keys].trim();
          let objs = {
            name: keys,
            emo: emos,
          };
          obj.arr.push(objs);
        }
        this.emoArr.push(obj);
      }
      console.log(this.emoArr);
    },
    focus() {
      let btnOne = document.getElementsByClassName('btn1')[0];
      btnOne.style.border = '1px solid #007aff';
    },
    blur() {
      let btnOne = document.getElementsByClassName('btn1')[0];
      btnOne.style.border = '1px solid #DCDFE6';
    },
  },
  mounted() {
    // console.log(emo.People);
    this.filterEmo(emo);
  },
  computed: {},
  created() {
    if (this.routeData !== '{}') {
      console.log(this.routeData, '============');
    }
  },
};
</script>
    <style scoped>
.wrap {
  width: 100%;
  background: #fff;
  /* border: 1px solid #c8c8c8; */
  padding: 20px;
  overflow: hidden;
  height: 660px;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.emoWrap {
  width: 100%;
  height: auto;
  /* padding: 20px; */
  overflow: hidden;
}

.fl-l {
  float: left;
}
.fl-r {
  float: right;
}
.btnClass {
  /* margin: 0 5px 0; */
  border-radius: 0 !important;
  border-top: none !important;
}
.btnWrap {
  width: 100%;
  position: absolute;
  margin-top: 0px;
  z-index: 9 !important;
  /* overflow: hidden; */
  /* margin-left: -5px; */
  border-radius: 0px;
  z-index: 99;
  background: #fff;
}
.emoItemWrap {
  overflow: hidden;
}

.emoItem:hover {
  font-size: 30px;
}
.emoItem {
  transition: 0.5s;
  font-size: 25px;
  cursor: pointer;
}

.el-tabs__header {
  margin: 0 !important;
}

>>> .el-tabs__item {
  height: 34px !important;
}

>>> #tab-Frequen {
  border: none !important;
}
</style>
    